module.exports = __webpack_public_path__ + "static/media/Futura_Condensed_Bd.f060e837.woff2";